import { RESET_ADVANCE_APPLICATION, UPDATE_ADVANCE_APPLICATION } from '../../../actions/CXC/Entry/AdvanceApplication';
import { initialAdvanceApplicationState, reduceAdvanceApplication } from '../../../../util/advanceApplicationReducer';

export default function CXCAdvanceApplication(state = initialAdvanceApplicationState(), action) {
  return reduceAdvanceApplication(state, action, RESET_ADVANCE_APPLICATION, UPDATE_ADVANCE_APPLICATION);
}
